(ns bec-cljs-common.worker
  (:require [clojure.core.async :as async]
            [taoensso.timbre :as log]))


;; TODO: Well, the name here matches lrn-utils.worker/go-task-handler!, but not much else. Try an API-compatible setup later?
(defn go-task-handler! "Executes tasks sent to `ch` while taking backpressure into account.
  Each task is a (fn [] ..) which must return a c.c.async/chan representing the (future) result of the task."
  [ch]
  (async/go-loop []
    (if-let [task (async/<! ch)]
      (do
        (try (let [res (async/<! (task))]
               #_(log/debug 'go-task-handler! res)
               res)
             (catch :default ex
               (log/warn ex "DEV: It is probably a good idea to have a try-catch in your tasks!")))
        (recur))
      (log/debug 'mk-task-worker ch "closed."))))


(defn def-task-handler [ch]
  (go-task-handler! ch)
  ch)


(defn with-result-ch
  ([f]
   (with-result-ch f (async/chan 1)))

  ([f result-ch]
   (fn []
     (f result-ch)
     result-ch)))
